import React from 'react'
import { connect } from 'react-redux'
import { isStandardRetailer } from '../../utils/retailer'
import SmartMenu from '../../../components/layout/navigation/components/SmartMenu'
import PromoBanner from '../common/PromoBanner'
import UpgradeAccountButton from '../common/UpgradeAccountButton'
import { SERVER } from '../../constants'
import adGif from "../../../assets/images/inventory_180_150_sr.gif"

import styles from './Navigation.module.css'

const Navigation = ({ isAdminUser, isBasicRetailer, retailerLink }) =>
  <aside id="left-panel">
    <nav className={styles.leftPanelNav}>
      <SmartMenu />
      {!isAdminUser &&
        <div>
          <div className={styles.liveProfile}>
            <a className="btn btn-primary" target="_blank" href={retailerLink}>
              Live Profile
            </a>
          </div>
          <ul>
            <li>
              <a href={SERVER} target="_blank" className={styles.marketPlace}>
                Gemsby Marketplace
              </a>
            </li>
          </ul>
        </div>}
    </nav>
    {isBasicRetailer
      ? <div className={styles.upgradeButtonContainer}>
          <UpgradeAccountButton className={styles.upgradeButton} />
        </div>
      : null}
    <PromoBanner
      className={styles.ad}
      imgSrc={adGif}
      // url="https://mydiamond.app.link/inventory_small"
    />
  </aside>

const mapStateToProps = ({ login }) => {
  const isAdminUser = login.get('isAdminUser')
  const currentUser = login.get('currentUser')
  let retailerLink = ''
  if (!isAdminUser && currentUser) {
    const publicLink = typeof currentUser.get === 'function' ? currentUser.get('publicLink') : currentUser.publicLink
    retailerLink = publicLink
      ? `${SERVER}/${publicLink}`
      : `${SERVER}/store/${encodeURIComponent(currentUser.id)}`
  }
  return {
    isAdminUser,
    isBasicRetailer: !isAdminUser && !!currentUser && !isStandardRetailer(currentUser),
    retailerLink
  }
}

export default connect(mapStateToProps)(Navigation)
